import { useFlag } from 'lane-shared/hooks';

import { FeatureFlag } from 'constants-flags';

export function useInspectionsTemplateCustomizeRevertAllEnabled() {
  const isEnabled = useFlag<boolean>(
    FeatureFlag.InspectionsTemplateCustomizeRevertAll,
    false
  );

  return Boolean(isEnabled);
}
